import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { useLocalStorage } from '@hooks';
import Tabs from '../../../components/Tabs/Tabs';
import Background from '../../../components/Background/Background';
import Highlight from '../../../components/Highlight/Highlight';
import generateExample from './generate-example';
import classes from './Code.styles.less';
const languages = ['.css', '.scss', '.jss'].map((language) => ({
    value: language,
    label: language,
}));
export default function Code({ values }) {
    const ls = useLocalStorage({ key: '@omatsuri/triangle-generator/code', delay: 10 });
    const [language, setLanguage] = useState(ls.retrieve() || '.css');
    const [elementExample, pseudoExample] = generateExample(language, values)[1];
    const handleLanguageChange = (l) => {
        setLanguage(l);
        ls.save(l);
    };
    return (_jsxs(Background, { className: classes.wrapper, children: [_jsx(Tabs, { data: languages, active: language, onTabChange: handleLanguageChange }), _jsxs("div", { className: classes.code, children: [_jsxs("div", { className: classes.section, children: [_jsx("div", { className: classes.title, children: "Element" }), _jsx(Highlight, { children: elementExample })] }), _jsxs("div", { className: classes.section, children: [_jsx("div", { className: classes.title, children: "Pseudo-element" }), _jsx(Highlight, { children: pseudoExample })] })] })] }));
}
